import { Router } from '@angular/router';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Campaign2Service } from 'app/services/campaign-2.0/campaign2.service';
import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';

@Component({
  selector: 'app-coupon-fruition-setup',
  templateUrl: './coupon-fruition-setup.component.html',
  styleUrls: ['./coupon-fruition-setup.component.css', '../coupon-setup.scss']
})
export class CouponFruitionSetupComponent implements OnInit {
  messageInstanceId: string;
  fruitionDatesForm: FormGroup;
  touchpoints: any[] = [];
  selectedTouchpoints: string[] = [];
  actionId: string;
  flgConfirmEmission = false;
  invalidSubmit = false;
  tpWithoutStores: number[];
  stateAction: string;
  campaignId: number;
  campaignActionId: number;
  actualStep: string = "fruition";
  emissionStartDate;
  emissionEndDate;
  defaultStartDate;
  defaultEndDate;
  idCampaign: number;
  flagCardHolder = false;
  cardHolderTypes: SelectItem[];
  selectedCardHolder: string;
  showFruitionDatesForm: boolean;
  actionTypeCode: string;
  barCode: string;
  checkBarcode: {
    start_emission_date?: any,
    end_emission_date?: any,
    start_fruition_date?: any,
    end_fruition_date?: any,
    flg_stop?: any,
    flg_warning?: any
  };
  ochannelInBoth: boolean = true;
  couponValidityStartDate: any[] = [];
  selectedCouponValidityStart: any;
  couponValidityEndDate: any[] = [];
  selectedCouponValidityEnd: any;
  flgRolling: any;
  startValidityValue: any;
  endValidityValue: any;
  couponUseType: any;
  startValidityBetweenFruition: boolean;
  endValidityBetweenFruition: boolean;
  constructor(
    private campaignService: Campaign2Service,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private translateService: TranslateService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private router: Router,
    public calendarTranslateService: CalendarTranslateService
  ) { }

  ngOnInit() {
    this.checkBarcode = {};
    this.messageInstanceId = this.activatedRoute.snapshot.params['messageInstanceId'];
    this.actionId = this.activatedRoute.snapshot.params['campaignActionId'];
    this.actionTypeCode = this.activatedRoute.snapshot.paramMap.get('actionTypeCode') || null;
    this.loadCouponValidity();
    this.campaignService.getMessageInstanceData(this.messageInstanceId).subscribe(res => {
      this.flgRolling =res[0].flg_rolling 
      this.idCampaign = res[0].campaign_id;
      this.couponUseType = res[0].flg_couponing_method == 'S' ? this.translateService.instant('common.static') : this.translateService.instant('common.dynamic')
      if (res[0].coupon_validity_date_start_mode && res[0].coupon_validity_date_end_mode) {
        setTimeout(() => {
          this.selectedCouponValidityStart = this.couponValidityStartDate.find(param => param.value.param_key === res[0].coupon_validity_date_start_mode).value;
          this.selectedCouponValidityEnd = this.couponValidityEndDate.find(param => param.value.param_key === res[0].coupon_validity_date_end_mode).value;
        }, 600)
        this.loadCouponValidityValue(res[0]);
      }
      if (res && res.length) {
        this.actionId = res[0]['campaign_action_id'].toString();
        this.setFormData(res[0]);
      } else {
        this.setFormData();
      }
      this.campaignService.getCampaignActionById(this.idCampaign, +this.actionId).subscribe( res => {
        this.emissionStartDate = new Date(res[0].start_date);
        this.emissionEndDate = new Date(res[0].end_date);
        this.checkBarcode.start_emission_date = res[0].start_date;
        this.checkBarcode.end_emission_date = res[0].end_date;
      })
      this.campaignService.getCampaign(this.idCampaign).subscribe( res => {
        this.defaultStartDate = new Date(res[0].start_date);
        this.defaultEndDate = new Date(res[0].end_date);
      })
      this.campaignService.getChannelByCampaignAction(this.actionId).subscribe( res => {
        if(res) {
          res.forEach(ochannel => {
            if(ochannel.flg_coupon_scope != 'B') {
              this.ochannelInBoth = false;
            }
          })
          console.log(this.ochannelInBoth)
        }
      })
    });
  }

  compareDatesForStartValidityDate() {
    if(this.flgRolling == 1) {
      if(!this.startValidityValue){
        this.startValidityValue = this.fruitionDatesForm.get('startDate').value;
      }
  
      if(!this.endValidityValue){
        this.endValidityValue = this.fruitionDatesForm.get('endDate').value;
      }
  
      if (this.selectedCouponValidityStart && this.selectedCouponValidityStart.param_functional_code == 'DATE') {
        this.startValidityBetweenFruition = this.startValidityValue >= this.fruitionDatesForm.get('startDate').value &&
          this.startValidityValue <= this.fruitionDatesForm.get('endDate').value;
      } 
      else this.startValidityBetweenFruition = true;
  
      if (this.selectedCouponValidityEnd && this.selectedCouponValidityEnd.param_functional_code == 'DATE') {
        this.endValidityBetweenFruition = this.endValidityValue >= this.fruitionDatesForm.get('startDate').value &&
          this.endValidityValue <= this.fruitionDatesForm.get('endDate').value;
      } 
      else this.endValidityBetweenFruition = true;
      
      return (this.startValidityBetweenFruition && this.endValidityBetweenFruition);
    }
    else return true;
  }

  setFormData(data?: any) {
    this.cardHolderTypes = [
      {label: '', value: null},
      {label: this.translateService.instant('campaign.specific'), value: 'S'},
      {label: this.translateService.instant('campaign.generic'), value: 'G'},
      {label: this.translateService.instant('campaign.customerCard'), value: 'C'}
    ];
    if (data) {
      this.campaignId = data.campaign_id;
      this.campaignActionId = data.campaign_action_id;
      this.stateAction = data.campaign_action_status_id;
      this.flagCardHolder = data.flg_card_holder == 1 ? true : false;
      this.selectedCardHolder = data.card_holder_type;
      this.barCode = data.barcode;  
      this.fruitionDatesForm = this.fb.group({
        startDate: data.start_fruition_date ? [new Date(data.start_fruition_date), Validators.required]: ['', Validators.required],
        endDate: data.end_fruition_date ? [new Date(data.end_fruition_date), Validators.required] : ['', Validators.required],
        //flgFlexibility: data.flg_date_flexibility === '1' ? true : false,
        //dayFlexibility: data.day_flexibility
      });
      if (this.fruitionDatesForm.controls.startDate.value && this.fruitionDatesForm.controls.endDate.value) {
        this.showFruitionDatesForm = false;
      } else {
        this.showFruitionDatesForm = true;
      }
    } else {

      this.fruitionDatesForm = this.fb.group({
        startDate: ['', Validators.required],
        endDate: ['', Validators.required],
        //flgFlexibility: false,
        //dayFlexibility: null
      });
    }
  }

  setTouchpoints(event) {
    this.touchpoints = event.touchpoints;
    this.selectedTouchpoints = event.selectedTouchpoints;
  }

  onTouchpointSelection(event: any) {
    this.selectedTouchpoints = event.selectedTouchpoints;
  }

  save() {
    this.tpWithoutStores = [];
    const campaignActionOchannelDtoList = [];
    if (!this.flgConfirmEmission && this.touchpoints && this.touchpoints.length > 0) {
      this.touchpoints.forEach(tp => {
        if (this.selectedTouchpoints.indexOf(tp.value.toString()) !== -1) {
          const channel = {
            ochannel_id: tp.value,
            storeMessageOchannelDtoList: []
          }
          if (tp.storesId.length > 0) {
            tp.storesId.forEach(storeId => channel.storeMessageOchannelDtoList.push({store_id: storeId}));
          }
          campaignActionOchannelDtoList.push(channel);
          // Se selezionato un touchpoint con flg_offline 1 senza negozi associati
          if (tp.flg_offline === '1' && tp.storesId.length === 0) {
            this.tpWithoutStores.push(tp.value);
          }
        }
      });
    }
    if (
      !this.fruitionDatesForm.valid ||
      !this.flgConfirmEmission && (
        !this.selectedTouchpoints ||
        this.selectedTouchpoints.length === 0 ||
        this.tpWithoutStores.length > 0
      ) ||
      (this.flgRolling == 1 && (
        !this.selectedCouponValidityStart || 
        !this.selectedCouponValidityEnd
      ))
    ) {
      console.log(this.flgConfirmEmission);
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    const data = {
      campaign_action_id: +this.actionId,
      scope: 'fruition',
      flg_card_holder: this.flagCardHolder ? 1 : 0,
      emission_store_confirmed: this.flgConfirmEmission ? '1' : '0',
      start_fruition_date: moment(this.fruitionDatesForm.get('startDate').value).format('YYYY-MM-DD'),
      end_fruition_date: moment(this.fruitionDatesForm.get('endDate').value).format('YYYY-MM-DD'),
      //flg_date_flexibility: this.fruitionDatesForm.get('flgFlexibility').value ? 1 : 0,
      //day_flexibility: (this.fruitionDatesForm.get('dayFlexibility').value && (this.fruitionDatesForm.get('flgFlexibility').value && this.fruitionDatesForm.get('flgFlexibility').value == 1)) ? this.fruitionDatesForm.get('dayFlexibility').value : 0,
      campaignActionOchannelDtoList,
      coupon_validity_date_start_mode: this.flgRolling == 1 ? this.selectedCouponValidityStart.param_key : null,
      coupon_validity_date_end_mode: this.flgRolling == 1 ? this.selectedCouponValidityEnd.param_key : null
    };
    if (this.flgRolling == 1) {
      this.checkCouponValidityType(data, this.selectedCouponValidityStart);
      this.checkCouponValidityType(data, this.selectedCouponValidityEnd);
      
      if((this.selectedCouponValidityStart.param_functional_code && !this.startValidityValue) || (this.selectedCouponValidityEnd.param_functional_code && !this.endValidityValue)) {
        this.invalidSubmit = true;
        return
      }
    }


    if (this.flagCardHolder && this.selectedCardHolder) {
      Object.assign(data, { card_holder_type: this.selectedCardHolder });
    } else if (this.flagCardHolder && !this.selectedCardHolder) {
      this.invalidSubmit = true;
      this.messageService.add({ severity: 'error', summary: this.translateService.instant('card.select_card') });
      return;
    }
    this.campaignService.saveMessageComplete(this.messageInstanceId, data).subscribe(() => {
      this.messageService.add({severity: 'success', summary: this.translateService.instant('common.success'), detail: this.translateService.instant('common.operation_success')});
      this.router.navigate([`campaign-coupon-layout-setup/${this.messageInstanceId}/${this.actionId}`, {
        actionTypeCode: this.actionTypeCode
      }]);
    });
  }

  setDefaultDateStart(formatted = false) {
    const startDate = this.fruitionDatesForm.controls.startDate.value;
    if (startDate) {
      if (formatted) {
        return moment(startDate).format(this.calendarTranslateService.pcalendarTranslate.dateFormatFilter.toUpperCase());
      } else {
        return startDate;
      }
    } else {
      return null;
    }
  }

  setDefaultDateEnd(formatted = false) {
    const endDate = this.fruitionDatesForm.controls.endDate.value;
    if (endDate) {
      if (formatted) {
        return moment(endDate).format(this.calendarTranslateService.pcalendarTranslate.dateFormatFilter.toUpperCase());
      } else {
        return endDate;
      }
    } else {
      return null;
    }
  }

  setStartDate() {
    if (!!this.fruitionDatesForm.get('startDate').value) {
      return this.fruitionDatesForm.get('startDate').value;
    } else {
      return this.emissionStartDate;
    }
  }

  setEndDate() {
    if (!!this.fruitionDatesForm.get('endDate').value) {
      return this.fruitionDatesForm.get('endDate').value;
    } else {
      return this.emissionEndDate;
    }
  }

  checkBarcodeAvailability() {
    if (this.fruitionDatesForm.get('startDate').value && this.fruitionDatesForm.get('endDate').value) {
      this.checkBarcode.start_fruition_date = moment(this.fruitionDatesForm.get('startDate').value).format('YYYY-MM-DD');
      this.checkBarcode.end_fruition_date = moment(this.fruitionDatesForm.get('endDate').value).format('YYYY-MM-DD');

      console.log(this.checkBarcode)
      this.campaignService.checkBarcodeAvailability(this.campaignId, this.barCode, this.messageInstanceId, this.checkBarcode).subscribe(res => {
        if (res) {
          this.checkBarcode.flg_stop = res.flg_stop
          this.checkBarcode.flg_warning = res.flg_warning

          if (this.checkBarcode.flg_stop === true) {
            this.confirmationService.confirm({
              header: this.translateService.instant('common.warning'),
              message: this.translateService.instant('campaign.checkBarcodeStop'),
              acceptLabel: 'Ok',
              rejectVisible: false
            })
          } else if (this.checkBarcode.flg_warning === true) {
            this.confirmationService.confirm({
              header: this.translateService.instant('common.warning'),
              message: this.translateService.instant('campaign.checkBarcodeWarning'),
              acceptLabel: 'Ok',
              accept: () => this.save(),
              rejectVisible: false
            })
          } else this.save();

        }

      });
    } else this.save();
  }

  loadCouponValidity() {
    this.couponValidityStartDate.push({ label: null, value: '' })
    this.couponValidityEndDate.push({ label: null, value: '' })
    this.campaignService.getValidityCoupon('start').subscribe(res => {
      if (res) {
        res.forEach(validity => {
          this.couponValidityStartDate.push({ label: this.translateService.instant(`couponValidity.${validity.description}`), value: validity })
        })
      }
    })
    this.campaignService.getValidityCoupon('end').subscribe(res => {
      if (res) {
        res.forEach(validity => {
          this.couponValidityEndDate.push({ label: this.translateService.instant(`couponValidity.${validity.description}`), value: validity })
        })
      }
    })
  }

  loadCouponValidityValue(res) {
    if (res.coupon_validity_date_start)
      this.startValidityValue = new Date(res.coupon_validity_date_start)
    else if (res.coupon_validity_start_offset_day)
      this.startValidityValue = res.coupon_validity_start_offset_day
    else if (res.coupon_validity_start_week_day)
      this.startValidityValue = res.coupon_validity_start_week_day

    if (res.coupon_validity_date_end)
      this.endValidityValue = new Date(res.coupon_validity_date_end)
    else if (res.coupon_validity_end_offset_day)
      this.endValidityValue = res.coupon_validity_end_offset_day
    else if (res.coupon_validity_end_week_day)
      this.endValidityValue = res.coupon_validity_end_week_day
  }

  getStartValidityValue(event) {
    this.startValidityValue = event;
  }

  getEndValidityValue(event) {
    this.endValidityValue = event;
  }

  checkCouponValidityType(data, couponValidity) {
    if(couponValidity.param_functional_code == 'NUMERIC') {
      if(couponValidity.param_code == 'start') {
        data.coupon_validity_start_offset_day = this.startValidityValue;
      } else {
        data.coupon_validity_end_offset_day = this.endValidityValue;
      }
    }
    else if(couponValidity.param_functional_code == 'DATE') {
      if(couponValidity.param_code == 'start') {
        data.coupon_validity_date_start = moment(this.startValidityValue).format('YYYY-MM-DD');
      } else {
        data.coupon_validity_date_end = moment(this.endValidityValue).format('YYYY-MM-DD');
      }
    }
    else if(couponValidity.param_functional_code == 'WEEK') {
      if(couponValidity.param_code == 'start') {
        data.coupon_validity_start_week_day = this.startValidityValue;
      } else {
        data.coupon_validity_end_week_day = this.endValidityValue;
      }
    }
    return data;
  }

  changeValidity() {
    this.invalidSubmit = false;
  }
  
}



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/coupon-fruition-setup/coupon-fruition-setup.component.ts